import { Caption } from '@depop/web-thrift-ui/Typography';

import styles from '@/app/[locale]/products/[slug]/components/ProductBadges/styles.module.css';

type Props = {
  label: string;
  className?: string;
};

export function DiscountBadge({ label, className }: Props) {
  return (
    <Caption
      variant="sm-bold"
      className={className || styles.discountLabel}
      as="span"
    >
      {label}
    </Caption>
  );
}
